var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.812 4.86l-2.86 2.866-1.1-1.1a.666.666 0 10-.94.94L5.479 9.14a.667.667 0 00.94 0l3.333-3.334a.666.666 0 10-.94-.946zM6.999.333a6.667 6.667 0 100 13.333 6.667 6.667 0 000-13.333zm0 12a5.334 5.334 0 110-10.667 5.334 5.334 0 010 10.667z",
    fill: "#fff"
  })));
}
export default SvgSuccessOutlined;